<template>
  <div class="pdf-wrapper text-center">
    <pdf ref="pdf" :src="source" @loaded="handlePdfLoaded" :page="currentPdfPage" :rotate="rotate"
         @num-pages="currentPagesCount = $event"></pdf>
    <div>
      <v-pagination
          v-model="currentPdfPage"
          :length="currentPagesCount"
          prev-icon="fas fa-caret-left"
          next-icon="fas fa-caret-right"
      ></v-pagination>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  name: 'PdfViewer',
  props: {
    source: String,
    rotate: {
      type: Number,
      default: 0
    },
  },
  components: {
    pdf
  },
  data() {
    return {
      currentPdfPage: 1,
      currentPagesCount: 0,
    }
  },
  methods: {
    handlePdfLoaded() {
      this.$emit('loaded', true)
    },
  }
}
</script>

<style scoped>
.pdf-wrapper {
  min-height: 500px;
  /*height: 500px;*/
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
</style>